import { createSlice } from "@reduxjs/toolkit";
import {
  bookMerchantService,
  getMerchantService,
  getMerchantServices,
} from "../actions/Merchant.action";
import {
  getAllServices,
  getServicesMaxPrice,
  updateUserGeolocation,
  getServiceDetailsByMerchantId,
  getServiceDetailsByMerchantIdAndMonth,
} from "store/actions/Service.action";

const initialLog = {
  type: "",
  error: false,
  message: null,
  loading: false,
  success: false,
};

const initialState = {
  loading: false,
  show: null,
  data: [],
  book: null,
  success: false,
  message: null,
  bookingDetails: null,
  services: {
    loading: false,
    success: false,
    error: false,
    data: [],
  },
  serviceDetails: {
    data: null,
    loading: false,
    error: null,
    success: null,
  },
  allServicesData: [],
  servicesMaxDistance: 100,
  servicesMaxPrice: null,
  selectedMerchantId: "",
  serviceDetailsByMerchantId: {},
  serviceDetailsByMerchantIdAndMonth: {},
  userGeolocation: { lat: null, lng: null },
  logs: initialLog,
};

const slice = createSlice({
  name: "Service",
  initialState,
  reducers: {
    clearServiceDetails: (state) => {
      state.serviceDetails = { data: null, loading: false, error: null };
    },
    setSelectedMerchantId: (state, action) => {
      state.selectedMerchantId = action.payload;
    },
    setServiceToBook: (state, action) => {
      state.book = action.payload;
    },
    setServiceAppointmentDateAndTime: (state, action) => {
      state.book.appointment = action.payload;
    },
    resetServicesLogs: (state) => {
      state.logs = initialLog;
      state.allServicesData = [];
      state.servicesMaxDistance = 100;
    },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(getMerchantService.pending, (state) => {
      //   state.loading = true;
      // })
      // .addCase(getMerchantService.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.show = action.payload.d;
      //   state.success = true;
      //   state.error = false;
      // })
      // .addCase(getMerchantService.rejected, (state, action) => {
      //   state.loading = false;
      //   state.success = false;
      //   state.error = true;
      //   state.message = action.payload.m;
      // })
      // NEW 👇
      .addCase(getAllServices.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "getAllServices",
        };
      })
      .addCase(getAllServices.fulfilled, (state, action) => {
        state.allServicesData = action.payload.d;
        state.servicesMaxDistance = action.payload.d.maxAvailableDistance;
        state.logs = { ...state.logs, success: true, loading: false };
      })
      .addCase(getAllServices.rejected, (state, action) => {
        state.logs = {
          ...state.logs,
          loading: false,
          error: action?.payload?.errors,
          message:
            action.payload?.m ||
            "Something went wrong getting rewards products.",
        };
      })
      .addCase(getServiceDetailsByMerchantId.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "getServiceDetailsByMerchantId",
        };
      })
      .addCase(getServiceDetailsByMerchantId.fulfilled, (state, action) => {
        state.serviceDetailsByMerchantId = action.payload.d;
        console.log("REDUX THUNK (getServiceDetailsByMerchantId) triggered");
        state.logs = { ...state.logs, success: true, loading: false };
      })
      .addCase(getServiceDetailsByMerchantId.rejected, (state, action) => {
        state.logs = {
          ...state.logs,
          loading: false,
          error: action?.payload?.errors,
          message:
            action.payload?.m ||
            "Something went wrong getting service details.",
        };
      })
      .addCase(getServiceDetailsByMerchantIdAndMonth.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "getServiceDetailsByMerchantIdAndMonth",
        };
      })
      .addCase(
        getServiceDetailsByMerchantIdAndMonth.fulfilled,
        (state, action) => {
          console.log(
            "REDUX THUNK (getServiceDetailsByMerchantIdAndMonth) triggered"
          );
          state.serviceDetailsByMerchantIdAndMonth = action.payload.d;
          state.logs = { ...state.logs, success: true, loading: false };
        }
      )
      .addCase(
        getServiceDetailsByMerchantIdAndMonth.rejected,
        (state, action) => {
          state.logs = {
            ...state.logs,
            loading: false,
            error: action?.payload?.errors,
            message:
              action.payload?.m ||
              "Something went wrong getting service details.",
          };
        }
      )
      .addCase(getServicesMaxPrice.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "getServicesMaxPrice",
        };
      })
      .addCase(getServicesMaxPrice.fulfilled, (state, action) => {
        state.servicesMaxPrice = action.payload.d;
        state.logs = { ...state.logs, success: true, loading: false };
      })
      .addCase(getServicesMaxPrice.rejected, (state, action) => {
        state.logs = {
          ...state.logs,
          loading: false,
          error: action?.payload?.errors,
          message:
            action.payload?.m ||
            "Something went wrong getting rewards products.",
        };
      })
      .addCase(updateUserGeolocation.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "updateUserGeolocation",
        };
      })
      .addCase(updateUserGeolocation.fulfilled, (state, action) => {
        state.userGeolocation = action.payload.d;
        state.logs = { ...state.logs, success: true, loading: false };
      })
      .addCase(updateUserGeolocation.rejected, (state, action) => {
        state.logs = {
          ...state.logs,
          loading: false,
          error: action?.payload?.errors,
          message:
            action.payload?.m ||
            "Something went wrong getting rewards products.",
        };
      })

      // OLD and EXISTING 👇
      .addCase(getMerchantServices.pending, (state) => {
        state.services.loading = true;
      })
      .addCase(getMerchantServices.fulfilled, (state, action) => {
        console.log(action);
        state.services.data = action.payload.d;
        state.services.success = true;
        state.services.error = false;
        state.services.loading = false;
      })
      .addCase(getMerchantServices.rejected, (state, action) => {
        state.services.data = null;
        state.message = action.payload?.m;
        state.services.success = false;
        state.services.error = true;
        state.services.loading = false;
      })
      .addCase(getMerchantService.pending, (state) => {
        state.serviceDetails.loading = true;
      })
      .addCase(getMerchantService.fulfilled, (state, action) => {
        state.serviceDetails.data = {
          ...action.payload.d,
          type: "services",
        };
        state.serviceDetails.success = true;
        state.serviceDetails.error = false;
        state.serviceDetails.loading = false;
      })
      .addCase(getMerchantService.rejected, (state, action) => {
        state.serviceDetails.data = null;
        state.message = action.payload?.m;
        state.serviceDetails.success = false;
        state.serviceDetails.error = true;
        state.serviceDetails.loading = false;
      });

    builder
      .addCase(bookMerchantService.pending, (state) => {
        state.loading = true;
      })
      .addCase(bookMerchantService.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingDetails = action.payload?.d;
        state.success = true;
        state.error = false;
      })
      .addCase(bookMerchantService.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = true;
        state.message = action.payload?.m;
      });
  },
});

export const { reducer: Service } = slice;

export const clearServiceDetails = () => (dispatch) => {
  dispatch(slice.actions.clearServiceDetails());
};

export const resetServicesLogs = (payload) => (dispatch) => {
  dispatch(slice.actions.resetServicesLogs(payload));
};

export const setSelectedMerchantId = (payload) => (dispatch) => {
  dispatch(slice.actions.setSelectedMerchantId(payload));
};

export const setServiceToBook = (payload) => (dispatch) => {
  dispatch(slice.actions.setServiceToBook(payload));
};

export const setServiceAppointmentDateAndTime = (payload) => (dispatch) => {
  dispatch(slice.actions.setServiceAppointmentDateAndTime(payload));
};

export default slice;
